export const tags = [
    "A",
    "B",
    "C",
    "D"
];